import { HttpErrorResponse } from "@angular/common/http";
import { ImportStatus } from "../import/import.state";

export interface ImportBatchDisableDeleteState {
  uploadLoader: boolean;
  uploadResult: boolean;
  uploadError: HttpErrorResponse;

  statusLoader: boolean;
  statusResult: ImportStatus; 
  statusError: HttpErrorResponse;

  authSSELoader: boolean;
  authSSEResult: boolean;
  authSSEError: HttpErrorResponse;

  errorListFile: string[];
  errorListLoader: boolean;
  errorListError: HttpErrorResponse;

  hasImportLoader: boolean;
  hasImportResult: number;
  hasImportError: HttpErrorResponse;

  cancelImportLoader: boolean;
  cancelImportResult: boolean | null;

  clearSessionLoader: boolean;
}

export const initialImportBatchDisableDeleteState: ImportBatchDisableDeleteState = {
  uploadLoader: false,
  uploadResult: null,
  uploadError: null,

  statusLoader: false,
  statusResult: null,
  statusError: null,

  authSSELoader: false,
  authSSEResult: false,
  authSSEError: null,

  errorListFile: [],
  errorListLoader: false,
  errorListError: null,

  hasImportLoader: false,
  hasImportResult: 0,
  hasImportError: null,

  cancelImportLoader: false,
  cancelImportResult: null,

  clearSessionLoader: false,
}